import { FlowLimitReturnType } from 'flow-schema';

import { api } from 'common';

import { FilterBlockFormFields } from './FormFields.tsx';
import { FilterBlockDocumentationMarkdown } from './documentation.ts';
import type { BlockConfigProps } from '../../types.ts';

export const filterListConfig: BlockConfigProps<api.FlowDefinition.FilterListBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'filterList',
  defaultConfig: {
    originalList: '',
    filterConfig: undefined,
    sortConfig: undefined,
    limitConfig: {
      returnType: FlowLimitReturnType.List,
      offset: 0,
    },
  },
  configFields: {
    schema: api.FlowDefinition.FilterListBlockConfigSchema,
    FormFields: FilterBlockFormFields,
  },
  documentationMarkdown: FilterBlockDocumentationMarkdown,
};
